import {Component} from '@angular/core';
import {BasePatientPage} from "../../base-patient-page";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {ImageUploadComponent} from "../../../../components/image/image-upload.component";
import {MatButton} from "@angular/material/button";
import {environment} from "../../../../../environments/environment";
import {SurveyQuestions} from "@allaihealth/survey";

@Component({
	selector: 'app-id',
	imports: [
		MatInputModule,
		FormsModule,
		MatCheckboxModule,
		ImageUploadComponent,
		MatButton
	],
	templateUrl: './id.component.html',
	styleUrl: './id.component.scss'
})
export class IdComponent extends BasePatientPage {
	protected imageSrcFront:string | ArrayBuffer;
	protected imageSrcBack:string | ArrayBuffer;

	async completeAll() {
		this.completeCategory(this.controller.id).then();
	}

	override ngOnInit() {
		super.ngOnInit();

		if(this.patientInfo?.data) {
			if(this.patientInfo.data[SurveyQuestions.SrcFrontId]) {
				this.http.get<{url:string;}>(`${environment.apiUrl}/patient/${this.patient.id}/image/${this.patientInfo.data[SurveyQuestions.SrcFrontId]}`).subscribe((value) => {
					fetch(value.url).then(response =>{
							response.text().then(text => {
								this.imageSrcFront = text;
							})
					});
				});
			}

			if(this.patientInfo.data[SurveyQuestions.SrcBackId]) {
				this.http.get<{url:string;}>(`${environment.apiUrl}/patient/${this.patient.id}/image/${this.patientInfo.data[SurveyQuestions.SrcBackId]}`).subscribe((value) => {
					fetch(value.url).then(response =>{
						response.text().then(text => {
							this.imageSrcBack = text;
						})
					});
				});
			}
		}
	}

	protected readonly SurveyQuestions = SurveyQuestions;
}
